import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { inject } from "@angular/core";
import { of } from "rxjs";

import { AppSessionService } from "../../services/app-session/app-session.service";

/**
 * Validate if a user is admin to access some pages.
 * @param route Route.
 * @param segments Segments.
 * @returns Observable boolean to know if continue to navigation.
 */
export const hasAdminProfile: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const appSessionService = inject(AppSessionService);
  const router = inject(Router);
  
  const session = appSessionService.session;

  if(session?.isAdmin) 
    return of(true);

  router.navigate(['/', 'explorer']);
  return of(false);
};